import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import {SearchFilterItem} from './searchfilteritem.component'

export class SearchFilter extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            filters: this.props.filters,
            activeFilters: []
        }

        _.bindAll(this,
    	'addFilter',
    	'removeFilter'
        )
    }

    addFilter(item) {
  	// CHECKBOX STYLE (OR)
    // this.setState({activeFilters:this.state.activeFilters.concat(this.props.filterMaps[item])}, function(){
	  // 	this.props.updateActiveFilters(this.state.activeFilters)
	  // })
    // RADIO STYLE (ONE AT A TIME)
        this.setState({activeFilters: item}, function() {
            this.props.updateActiveFilters(this.state.activeFilters)
        })
    }

    removeFilter(item) {
    // let activeFilters = this.state.activeFilters
    // let removeFilters = this.props.filterMaps[item]

    // _.each(this.props.filterMaps[item], function(item){
    //   if(activeFilters.indexOf(item) > -1){
    //     activeFilters.splice(activeFilters.indexOf(item), 1)
    //   }
    // })  
      
    // this.setState({activeFilters: activeFilters}, function(){
    //   this.props.updateActiveFilters(this.state.activeFilters)
    // })

        this.setState({activeFilters: []}, function() {
            this.props.updateActiveFilters(this.state.activeFilters)
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filters != this.state.filters) {
            this.setState({filters: nextProps.filters})
        }
    }

    render() {
        var filterItems = null
        if (this.state.filters) {
            filterItems = this.state.filters.map(function(item, i) {
                return <SearchFilterItem key={i} item={item} addFilter={this.addFilter} removeFilter={this.removeFilter} activeFilters={this.state.activeFilters}/>
            }, this)
        }

        return (
            <div id="search-filters" className="row">{filterItems}</div>
        )
    }
}
